import { render, staticRenderFns } from "./ModuleBox.vue?vue&type=template&id=52b60bee&scoped=true&"
import script from "./ModuleBox.vue?vue&type=script&lang=js&"
export * from "./ModuleBox.vue?vue&type=script&lang=js&"
import style0 from "./ModuleBox.vue?vue&type=style&index=0&id=52b60bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b60bee",
  null
  
)

export default component.exports